	<ng-template>
		<ngx-skeleton-loader *ngIf="isLoading" count="5" [theme]="{ width: '200px', height: '200px' }"></ngx-skeleton-loader>
	</ng-template>
	<div *ngIf="!isLoading">
			<apx-chart
				id="cyberscore"
				[chart]="options.chart"
				[series]="options.series"
				[plotOptions]="options.plotOptions"
				[dataLabels]="options.dataLabels"
				[labels]="options.labels"
				[colors]="options.colors"
				[fill]="options.fill"
				[stroke]="options.stroke"
				[grid]="options.grid"
				[states]="options.states"
				[responsive]="options.responsive"
			>
			</apx-chart>
	</div>
